// apis/dealertipoutService.js
import authApiService from "./userApiService";

const handleError = (error) => {
  console.error('API Error:', error);
  return {
    success: false,
    error: error.response?.data?.error || error.message || 'An error occurred',
    statusCode: error.response?.status
  };
};

const handleSuccess = (response) => ({
  success: true,
  data: response.data,
  statusCode: response.status
});

export const dealertipoutService = {
  async getBalances() {
    try {
      const response = await authApiService.get("/dealer-tips/balances");
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async getRecords() {
    try {
      const response = await authApiService.get("/dealer-tips/records");
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async getEmployees() {
    try {
      const response = await authApiService.get("/dealer-tips/employees");
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async addRecord(data) {
    try {
      // Convert amount to number before sending
      const payload = {
        empname: data.empname,
        amountcash: parseFloat(data.amountcash)
      };
      
      console.log("Sending payload:", payload);
      const response = await authApiService.post("/dealer-tips", payload);
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async updateRecord(id, data) {
    try {
      const response = await authApiService.put(`/dealer-tips/${id}`, data);
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async deleteRecord(id) {
    try {
      const response = await authApiService.delete(`/dealer-tips/${id}`);
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  // New method for getting overall totals
  async getOverallTotals(startDate, endDate) {
    const response = await authApiService.get('/dealer-tips/overall-totals', {
        params: {
            startDate,
            endDate
        }
    });
    return response.data;
  }
};